module.exports = __webpack_public_path__ + "static/media/techno-1.399a04a7.png";